var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9502 20.0184C40.9502 8.97265 31.9959 0.0183563 20.9502 0.0183563C9.90449 0.0183563 0.950195 8.97265 0.950195 20.0184C0.950195 30.0009 8.26391 38.275 17.8252 39.7754V25.7996H12.7471V20.0184H17.8252V15.6121C17.8252 10.5996 20.8111 7.83086 25.3795 7.83086C27.5677 7.83086 29.8564 8.22148 29.8564 8.22148V13.1434H27.3345C24.85 13.1434 24.0752 14.685 24.0752 16.2667V20.0184H29.6221L28.7354 25.7996H24.0752V39.7754C33.6365 38.275 40.9502 30.0009 40.9502 20.0184Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7354 25.7988L29.6221 20.0176H24.0752V16.2659C24.0752 14.6843 24.85 13.1426 27.3345 13.1426H29.8564V8.2207C29.8564 8.2207 27.5677 7.83008 25.3795 7.83008C20.8111 7.83008 17.8252 10.5988 17.8252 15.6113V20.0176H12.7471V25.7988H17.8252V39.7746C18.8434 39.9344 19.8871 40.0176 20.9502 40.0176C22.0133 40.0176 23.057 39.9344 24.0752 39.7746V25.7988H28.7354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIco);
export default __webpack_public_path__ + "static/media/fb__ico.8bd6f8e93fa3a0a3477eb71ed63c0e30.svg";
export { ForwardRef as ReactComponent };